import { createContext, useContext } from "react";
/**
 * How an item closes the drawer it sits in. Provided by the temporary drawer;
 * the permanent one has nothing to close, so the default does nothing.
 */
const CloseAppDrawerContext = createContext(() => undefined);
export const CloseAppDrawerProvider = CloseAppDrawerContext.Provider;
export const useCloseAppDrawer = () => useContext(CloseAppDrawerContext);
//# sourceMappingURL=AppDrawerContext.js.map